export default "__VITE_PUBLIC_ASSET__3b4a741a__"